var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.803,
    height: 16.801,
    viewBox: "0 0 19.803 16.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change",
    transform: "translate(-330.858 -161.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_934",
    "data-name": "Pfad 934",
    d: "M338.588,173.188l-2.2,2.2V162.558a.9.9,0,0,0-1.8,0v12.827l-2.2-2.2a.9.9,0,1,0-1.273,1.274l3.733,3.733a.22.22,0,0,0,.02.013.875.875,0,0,0,.272.181.883.883,0,0,0,.689,0,.879.879,0,0,0,.273-.181c.006,0,.014-.007.019-.013l3.734-3.733a.9.9,0,0,0-1.274-1.274Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_935",
    "data-name": "Pfad 935",
    d: "M350.4,165.655l-3.733-3.733a.233.233,0,0,0-.02-.013.868.868,0,0,0-.273-.181.9.9,0,0,0-.689,0,.874.874,0,0,0-.272.181.224.224,0,0,0-.02.013l-3.733,3.733a.9.9,0,0,0,1.273,1.274l2.2-2.2v12.826a.9.9,0,1,0,1.8,0V164.732l2.2,2.2a.9.9,0,0,0,1.273-1.274Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.c242effefc5b90bd02e6fbc9e2e3e2e0.svg";
export { ForwardRef as ReactComponent };